(() => {
  const MODE_KEY = 'laymela-discreet-mode';
  const MODE_VERSION_KEY = 'laymela-discreet-mode-version';
  const MODE_VERSION = '2026-09-23-privacy-1';
  const root = document.documentElement;
  const config = window.LaymelaConfig || {};
  const protectedImageSelector = [
    'main [class*="ai-image-gallery-image-wrapper-"] img',
    'main[data-template^="collection"] .image-block img',
    'main .product-media-container img',
    'main product-card img',
    'main .product-card img',
    'main comparison-slider-component img',
    'main [class*="ai-comparison-slider"] img',
  ].join(',');
  let originalTitle = window.laymelaOriginalTitle || document.title;

  const safeStorage = {
    get(defaultValue = false) {
      try {
        const savedVersion = window.localStorage.getItem(MODE_VERSION_KEY);
        if (savedVersion !== MODE_VERSION) {
          this.set(defaultValue);
          return defaultValue;
        }
        const saved = window.localStorage.getItem(MODE_KEY);
        return saved === null ? defaultValue : saved === 'true';
      }
      catch (error) { return root.classList.contains('laymela-discreet'); }
    },
    set(value) {
      try {
        window.localStorage.setItem(MODE_KEY, String(value));
        window.localStorage.setItem(MODE_VERSION_KEY, MODE_VERSION);
      }
      catch (error) {}
    },
  };

  function updatePrivacyControls(enabled, announce = false) {
    root.classList.toggle('laymela-discreet', enabled);
    document.querySelectorAll('[data-laymela-discreet-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(enabled));
      const label = button.querySelector('[data-laymela-discreet-label]');
      if (label) label.textContent = `${config.discreetLabel || 'Discreet mode'}: ${enabled ? 'On' : 'Off'}`;
    });
    document.title = enabled ? 'Laymela' : originalTitle;
    if (!enabled) document.querySelectorAll('.laymela-revealed').forEach((item) => item.classList.remove('laymela-revealed'));
    if (announce) {
      const status = document.querySelector('[data-laymela-privacy-status]');
      if (status) status.textContent = `Discreet browsing mode ${enabled ? 'enabled' : 'disabled'}.`;
    }
  }

  function decorateSensitiveContent() {
    document.querySelectorAll('[class*="ai-image-gallery-item-"]').forEach((card) => card.classList.add('laymela-design-card'));
    document.querySelectorAll('comparison-slider, comparison-slider-component').forEach((panel) => panel.classList.add('laymela-sensitive-panel'));
    document.querySelectorAll('main *').forEach((element) => {
      if (element.tagName.toLowerCase().startsWith('comparison-carousel-')) element.classList.add('laymela-sensitive-panel');
    });
    document.querySelectorAll('main product-information, main .product-information').forEach((product) => product.classList.add('laymela-sensitive-product'));
  }

  function initMediaProtection() {
    if (config.mediaProtectionEnabled === false) return;
    root.classList.add('laymela-media-protected');

    function protectImages() {
      document.querySelectorAll(protectedImageSelector).forEach((image) => {
        image.draggable = false;
        image.setAttribute('draggable', 'false');
      });
    }

    protectImages();
    document.addEventListener('contextmenu', (event) => {
      if (event.target.closest?.(protectedImageSelector)) event.preventDefault();
    }, true);
    document.addEventListener('dragstart', (event) => {
      if (event.target.closest?.(protectedImageSelector)) event.preventDefault();
    }, true);

    const main = document.querySelector('main');
    if (main && 'MutationObserver' in window) {
      const observer = new MutationObserver(protectImages);
      observer.observe(main, { childList: true, subtree: true });
    }
  }

  function handleDiscreetReveal(event) {
    if (!root.classList.contains('laymela-discreet')) return;
    const status = document.querySelector('[data-laymela-privacy-status]');
    const designCard = event.target.closest('.laymela-design-card.laymela-discreet-blur, .laymela-design-card.laymela-discreet-name');

    if (designCard) {
      const explicitShopLink = event.target.closest('.laymela-shop-label');
      if (explicitShopLink && designCard.classList.contains('laymela-revealed')) return;
      // fix-1029: once revealed, clicking the title/caption opens the design page
      // fix-1029e: the title/caption always opens the design page; only the art area reveals
      if (event.target.closest('.ai-image-gallery-caption-laymela')) return;

      event.preventDefault();
      event.stopPropagation();
      const revealed = designCard.classList.toggle('laymela-revealed');
      if (status) {
        status.textContent = revealed
          ? 'Preview revealed. Click the title to open the design, or the image again to conceal it.'
          : 'Preview concealed.';
      }
      return;
    }

    const sensitive = event.target.closest('.laymela-sensitive-panel, .laymela-sensitive-product');
    if (!sensitive || sensitive.classList.contains('laymela-revealed')) return;
    // Only a tap on the blurred media reveals it; never swallow clicks on buy buttons, pickers, links or form controls.
    if (event.target.closest('a, button, input, select, textarea, label, summary, form, [role="button"]')) return;
    if (!event.target.closest('img, picture, video, media-gallery, .product-media, .product-media-container, slideshow-component')) return;
    event.preventDefault();
    event.stopPropagation();
    sensitive.classList.add('laymela-revealed');
    if (status) status.textContent = 'Preview revealed.';
  }

  const filterGroups = {
    all: [],
    roles: ['dominant', 'dom ', 'dom)', 'submissive', 'sub ', 'sub)', 'master', 'mistress', 'goddess', 'queen', 'sir', 'ma’am', "ma'am", 'alpha', 'brat', 'bull', 'hotwife', 'cuckold', 'maid', 'butler', 'little', 'sissy', 'service', 'rope top', 'rope bottom', 'rope switch', 'stag', 'vixen', 'voyeur', 'exhibitionist'],
    relationships: ['hotwife', 'bull', 'cuck', 'swinger', 'non-monogamy', 'threesome', 'mfm', 'mmf', 'stag', 'vixen', 'party of three', 'double booked', 'flr', 'female led relationship'],
    'kink-activities': ['dominance', 'submission', 'protocol', 'power exchange', 'tpe', 'rope', 'shibari', 'bondage', 'chastity', 'locked', 'keyholder', 'key holder', 'impact', 'spank', 'paddle', 'orgasm control', 'pet play', 'pain', 'masochist', 'voyeur', 'exhibitionist', 'cuckolding', 'creampie'],
    'sexual-activities': ['anal', 'cunnilingus', 'creampie', 'bukkake', 'double penetration', 'threesome', 'mfm', 'mmf', 'cumdump', 'cum slut'],
    'philia-fetish': ['feet', 'foot', 'shoe', 'suit porn', 'leather', 'size queen', 'hedonist', 'voyeur', 'exhibitionist', 'paddle addict'],
    'toys-and-equipment': ['paddle', 'rope', 'chastity', 'locked', 'keyholder', 'key holder', 'collar', 'cuff'],
    genders: [],
    'sexual-orientations': [],
    'romantic-orientations': [],
    'gay-culture': [],
    holidays: ['holiday', 'christmas', 'santa', 'valentine', 'halloween', 'easter'],
    'pop-culture': [],
  };

  function normalizeFilterTag(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/\//g, '-')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-');
  }

  function initGalleryTools() {
    if (config.galleryToolsEnabled === false) return;
    if (!window.location.pathname.includes('/collections/')) return;
    const cards = [...document.querySelectorAll('.laymela-design-card')];
    const galleries = [...document.querySelectorAll('main [class^="ai-image-gallery-"]')].filter((gallery) => gallery.tagName.toLowerCase().startsWith('image-gallery-'));
    if (cards.length < 8 || !galleries.length) return;
    galleries.forEach((gallery) => gallery.classList.add('laymela-gallery-source'));

    const tools = document.createElement('section');
    tools.className = 'laymela-gallery-tools';
    tools.setAttribute('aria-label', 'Explore designs');
    tools.innerHTML = `
      <div class="laymela-gallery-tools__top">
        <h2 class="laymela-gallery-tools__title">Find your signal</h2>
        <span class="laymela-gallery-tools__count" aria-live="polite"></span>
      </div>
      <input type="search" autocomplete="off" spellcheck="false" placeholder="Search designs discreetly" aria-label="Search designs">
      <div class="laymela-gallery-tools__filters" aria-label="Design categories">
        <button class="laymela-gallery-filter" type="button" data-filter="all" aria-pressed="true">All</button>
        <button class="laymela-gallery-filter" type="button" data-filter="roles" aria-pressed="false">Roles</button>
        <button class="laymela-gallery-filter" type="button" data-filter="relationships" aria-pressed="false">Relationships</button>
        <button class="laymela-gallery-filter" type="button" data-filter="kink-activities" aria-pressed="false">Kink Activities</button>
        <button class="laymela-gallery-filter" type="button" data-filter="sexual-activities" aria-pressed="false">Sexual Activities</button>
        <button class="laymela-gallery-filter" type="button" data-filter="philia-fetish" aria-pressed="false">Philia/Fetish</button>
        <button class="laymela-gallery-filter" type="button" data-filter="toys-and-equipment" aria-pressed="false">Toys & Equipment</button>
        <button class="laymela-gallery-filter" type="button" data-filter="genders" aria-pressed="false">Genders</button>
        <button class="laymela-gallery-filter" type="button" data-filter="sexual-orientations" aria-pressed="false">Sexual Orientations</button>
        <button class="laymela-gallery-filter" type="button" data-filter="romantic-orientations" aria-pressed="false">Romantic Orientations</button>
        <button class="laymela-gallery-filter" type="button" data-filter="gay-culture" aria-pressed="false">Gay Culture</button>
        <button class="laymela-gallery-filter" type="button" data-filter="holidays" aria-pressed="false">Holidays</button>
        <button class="laymela-gallery-filter" type="button" data-filter="pop-culture" aria-pressed="false">Pop Culture</button>
      </div>`;
    galleries[0].before(tools);

    const results = document.createElement('section');
    results.className = 'laymela-gallery-results';
    results.setAttribute('aria-label', 'Filtered designs');
    results.hidden = true;
    const resultsGrid = document.createElement('div');
    resultsGrid.className = 'laymela-gallery-results__grid';
    results.append(resultsGrid);
    tools.after(results);

    const search = tools.querySelector('input[type="search"]');
    const count = tools.querySelector('.laymela-gallery-tools__count');
    const buttons = [...tools.querySelectorAll('[data-filter]')];
    let activeFilter = new URLSearchParams(window.location.search).get('lm_filter') || 'all';
    if (root.classList.contains('laymela-discreet') && ['sexual-activities', 'philia-fetish', 'kink-activities'].includes(activeFilter)) activeFilter = 'all';
    if (!Object.prototype.hasOwnProperty.call(filterGroups, activeFilter)) activeFilter = 'all';

    const categoryKeys = Object.keys(filterGroups).filter((key) => key !== 'all');
    function keywordMatches(caption, keyword) {
      const word = keyword.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      if (!word) return false;
      return new RegExp(`(^|[^a-z0-9])${word}($|[^a-z0-9])`).test(caption);
    }
    function cardMatchesCategory(card, filter) {
      if (filter === 'all') return true;
      const caption = (card.dataset.laymelaCaption || '').trim().toLowerCase();
      const tags = (card.dataset.laymelaTags || '')
        .split(/[,;|]/)
        .map(normalizeFilterTag)
        .filter(Boolean);
      // Curated category tags win. Keyword guessing is only a fallback for tiles with no category tag,
      // and only matches whole words in the design name (never labels or the Discreet title).
      if (tags.some((tag) => categoryKeys.includes(tag))) return tags.includes(filter);
      return filterGroups[filter].some((keyword) => keywordMatches(caption, keyword));
    }

    buttons.forEach((button) => {
      if (button.dataset.filter === 'all') return;
      button.hidden = !cards.some((card) => cardMatchesCategory(card, button.dataset.filter));
    });
    if (activeFilter !== 'all' && !cards.some((card) => cardMatchesCategory(card, activeFilter))) activeFilter = 'all';

    function applyFilters() {
      const query = search.value.trim().toLowerCase();
      const matchingCards = cards.filter((card) => {
        const caption = (card.dataset.laymelaCaption || '').trim().toLowerCase();
        const text = caption;
        const rawTags = (card.dataset.laymelaTags || '').toLowerCase();
        const tags = rawTags
          .split(/[,;|]/)
          .map(normalizeFilterTag)
          .filter(Boolean);
        const searchMatch = !query || `${caption} ${text} ${rawTags} ${tags.join(' ')}`.includes(query);
        return cardMatchesCategory(card, activeFilter) && searchMatch;
      });

      const filtering = activeFilter !== 'all' || query.length > 0;
      root.classList.toggle('laymela-gallery-filtering', filtering);
      galleries.forEach((gallery) => {
        if (filtering) gallery.setAttribute('hidden', '');
        else gallery.removeAttribute('hidden');
      });
      results.hidden = !filtering;
      resultsGrid.replaceChildren();

      if (filtering && matchingCards.length) {
        matchingCards.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.classList.add('laymela-filter-result');
          clone.removeAttribute('hidden');
          clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          resultsGrid.append(clone);
        });
      }
      else if (filtering) {
        const empty = document.createElement('p');
        empty.className = 'laymela-gallery-results__empty';
        empty.innerHTML = query
          ? '<strong class="laymela-gallery-results__empty-title">No designs found</strong><span>Nothing matches \u201c' + query.replace(/[&<>"']/g, '') + '\u201d. Try another word or <a href="#" data-lm-clear-search>clear the search</a>.</span>'
          : '<strong class="laymela-gallery-results__empty-title">No designs found</strong><span>No designs match this filter yet.</span>';
        empty.querySelector('[data-lm-clear-search]')?.addEventListener('click', (event) => { event.preventDefault(); search.value = ''; applyFilters(); search.focus(); });
        resultsGrid.append(empty);
      }

      count.textContent = `${matchingCards.length} design${matchingCards.length === 1 ? '' : 's'}`;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === activeFilter)));
    }

    buttons.forEach((button) => button.addEventListener('click', () => { activeFilter = button.dataset.filter; applyFilters(); }));
    search.addEventListener('input', applyFilters);
    applyFilters();
  }

  function init() {
    originalTitle = window.laymelaOriginalTitle || document.title;
    document.querySelectorAll('a[href="/pages/contact"]').forEach((link) => {
      if (/design request/i.test(link.textContent || '')) link.href = '/pages/request';
    });
    decorateSensitiveContent();
    initMediaProtection();
    initGalleryTools();
    updatePrivacyControls(config.discreetEnabled === false ? false : safeStorage.get(config.discreetDefaultOn === true));
    // fix-1029h: Discreet Mode search pages never echo the typed query
    if (window.location.pathname.startsWith('/search')) {
      const syncSearchEcho = () => {
        const on = root.classList.contains('laymela-discreet');
        document.querySelectorAll('main input[type="search"], main input[name="q"]').forEach((input) => {
          if (!input.dataset.lmQuery) input.dataset.lmQuery = input.value;
          if (on && input.value === input.dataset.lmQuery) input.value = '';
          if (!on && !input.value) input.value = input.dataset.lmQuery;
        });
      };
      syncSearchEcho();
      new MutationObserver(syncSearchEcho).observe(root, { attributes: true, attributeFilter: ['class'] });
    }
    document.querySelectorAll('[data-laymela-discreet-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const enabled = !root.classList.contains('laymela-discreet');
        safeStorage.set(enabled);
        updatePrivacyControls(enabled, true);
      });
    });
    document.querySelectorAll('[data-laymela-quick-exit]').forEach((button) => {
      button.addEventListener('click', () => window.location.replace(button.dataset.exitUrl || 'https://www.google.com/'));
    });
    document.addEventListener('click', handleDiscreetReveal, true);

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', () => {
        window.requestAnimationFrame(() => {
          decorateSensitiveContent();
          if (!document.querySelector('.laymela-gallery-tools')) initGalleryTools();
          if (!root.classList.contains('laymela-gallery-filtering')) {
            document.querySelectorAll('.laymela-gallery-source[hidden]').forEach((gallery) => gallery.removeAttribute('hidden'));
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
